import React, { useEffect, useState } from 'react'
import { Loader } from 'rsuite'

import SimpleUser from './SimpleUser'
import UserIsAdmin from './UserIsAdmin'
import { checkForAdmin } from '../../../Context/firebase'

const SendResetPasswordEmailModal = ({
  userData, setModalVisible, resetPassword
}) => {
  const [loading, setLoading] = useState(false)
  const [userRole, setUserRole] = useState(false)
  const userId = userData.uid

  useEffect(async () => {
    setLoading(true)
    const role = await checkForAdmin(userId)
    setUserRole(role)
    setLoading(false)
  }, [])

  // sendResetEmail(rowData, resetPassword)

  return (
    <>
      {loading && <Loader backdrop size='lg' content='loading...' vertical />}
      {userRole === 'admin'
        ? <UserIsAdmin
          setModalVisible={setModalVisible}
        />
        : <SimpleUser
          userData={userData}
          loading={loading}
          setLoading={setLoading}
          setModalVisible={setModalVisible}
          resetPassword={resetPassword}
        />}
    </>
  )
}

export default SendResetPasswordEmailModal
